import { render } from "./AgendarConsultaDadosHistoricos.vue?vue&type=template&id=fd069538&scoped=true"
import script from "./AgendarConsultaDadosHistoricos.vue?vue&type=script&lang=js"
export * from "./AgendarConsultaDadosHistoricos.vue?vue&type=script&lang=js"

import "./AgendarConsultaDadosHistoricos.vue?vue&type=style&index=0&id=fd069538&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd069538"]])

export default __exports__